module.exports = "<diner-summary-header></diner-summary-header>\n<hr class=\"hr--thin\"/>\n<order-diner-summary-restaurant ctrl=\"ctrl\"></order-diner-summary-restaurant>\n<delivery-total-summary ctrl=\"ctrl\" type=\"RESTAURANT\"></delivery-total-summary>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/dinerSummaryRestaurant.html
// module id = 782
// module chunks = 0